import { callApi } from '@/_core/api/apiWrapper'

export const loginUser = async () => {
  const response = await callApi({
    method: 'get',
    url: 'auth/login/id',
    authRequired: false
  })
  return response
}

export const logoutUser = async () => {
  const response = await callApi({
    method: 'get',
    url: 'logout/'
  })
  return response
}
